<i18n>
{
  "en": {
    "messages": {
      "title": "E-mail address confirm",
      "mailConfirmOKMessage": "E-mail address was confirmed.",
      "mailConfirmErrorMessage": "E-mail address was not confirmed.",
      "sessionErrorMessage": "An error occurred during authentication of the email address. There is a possibility that the session has run out. We apologize for the inconvenience, but please re-do it again from the certification email.",
      "instagramLoginMessage": "Then, let us verify your Instagram account. Authenticate your account with the following Instagram authentication button. <br /> Instagram login is performed only to confirm the validity of Instagram account <br /> Instagram password will not be recorded on this site. Also, there is no such thing as posting to Instagram from us.",
      "confirmLoginedAccount": "I am logged in with my Instagram account that received direct message.(Make sure you're not logged in to your browser or app with the wrong account.)",
      "instagramLoginAlart": "※Instagram login may not work properly temporarily. If it doesn't work, please try again later.",
      "inquiry1": "If you can not login, please contact us from ",
      "inquiry2": "here",
      "inquiry3": "",
      "instagramUserName": "Instagram user name",
      "defaultErrorMessage": "Invalid user name.",
      "enterButton": "Enter",

      "twitterLoginMessage": "Then, let us verify your Twitter account. Authenticate your account with the following Twitter authentication button. <br /> Twitter login is performed only to confirm the validity of Twitter account <br /> Twitter password will not be recorded on this site. Also, there is no such thing as posting to Twitter from us.",
      "twitterEnterButton": "Twitter authentication"
    }
  },
  "ja": {
    "messages": {
      "title": "メールアドレス確認",
      "mailConfirmOKMessage": "メールアドレスは問題無く確認されました。",
      "mailConfirmErrorMessage": "メールアドレスの認証でエラーが発生しました。<br />再度URLをご確認ください。",
      "sessionErrorMessage": "メールアドレスの認証でエラーが発生しました。セッション切れの可能性があります。お手数ですが、再度認証メールの送信から実施をお願いします。",
      "instagramLoginMessage": "・続いて、Instagramユーザーネームの認証を行います。以下の入力フォームにユーザーネームを入力してください。<br />・Instagramユーザーネームは、受賞候補となっている作品を投稿したアカウントのユーザーネームを入力してください。<br />・受賞候補となっている作品を投稿したアカウント以外のユーザーネームは使用できません。",
      "confirmLoginedAccount": "現在のブラウザでダイレクトメッセージを受け取ったInstagramアカウントでログインしています。",
      "instagramLoginAlart": "※Instagramログインが一時的に正常に動作しない場合があります。何度やってもログインできない場合は時間をおいて再度お試しください。",
      "inquiry1": "認証ができない場合は",
      "inquiry2": "こちら",
      "inquiry3": "よりお問い合わせください。",
      "instagramUserName": "Instagramユーザーネーム",
      "defaultErrorMessage": "不正なユーザーネームです。",
      "enterButton": "認証",

      "twitterLoginMessage": "・続いて、Twitterアカウントの本人確認を行います。以下のTwitter認証機能で、アカウントを認証してください。<br />・なお、Twitterログインは、受賞候補者本人であることを確かめるためにのみ使用しています。<br />・ボタンを押すと、Twitterが提供する認証画面が表示されますので、ログイン後に内容を確認して「連携アプリを認証」ボタンを押してください。<br />・現在のブラウザ上でTwitterにログインしていない方は、次の画面でログイン画面が表示されます。ログインしていただくと自動的にTwitter認証画面に進みます。<br />・Twitterのパスワードが当サイトに記録されることはありません。また、当サイトからTwitterに投稿が行われるようなこともありません。",
      "twitterEnterButton": "Twitterアカウント認証"
    }
  }
}
</i18n>

<template>
  <v-layout row align-center wrap>
    <v-flex text-xs-center xs12 sm12 md12>
      <!-- <v-img :src="keyVisualSrc"></v-img> -->
      <h3 class="signup-message">
        <!-- {{ campaign.name + $t('messages.title') }} -->
        <v-flex
          v-if="!hasError"
          text-xs-center
          class="login-notice"
          v-html="$t('messages.mailConfirmOKMessage')"
        ></v-flex>
      </h3>
      <v-alert
        v-if="hasUnexpectedError"
        class="signup-errormessage"
        :value="true"
        color="error"
        icon="warning"
        outline
      >
        <span v-html="$t('messages.mailConfirmErrorMessage')"></span>
      </v-alert>

      <v-alert
        v-if="hasSessionError"
        :value="true"
        color="error"
        icon="warning"
        outline
      >
        <span v-html="$t('messages.sessionErrorMessage')"></span>
      </v-alert>

      <hr class="app-hr" />
    </v-flex>
    <v-flex text-xs-left v-if="isInstagram">
      <v-card
        class="mb-3 elevation-0"
        color="grey lighten-4"
        style="padding: 15px;"
      >
        <v-flex v-html="$t('messages.instagramLoginMessage')"></v-flex>
      </v-card>
      <div style="display: flex; flex-direction: row; justify-content: center; padding: 12px;">
        <v-card style="width: 100%; max-width: 500px; padding: 16px; display: flex; flex-direction: column; align-items: center;">
          <TextInput
            name="instagramUserName"
            v-model="instagramUserName"
            :placeholderValue="$t('messages.instagramUserName')"
            v-validate="'required|email'"
            style="width: 100%;"
          />
          <div v-if="hasError" style="color: red; width: 100%; padding: 16px; padding-top: 0px; text-align: left;">
            <span style="white-space: pre-wrap;">{{
              apiErrorMessage
            }}</span>
          </div>
          <v-btn
            color="primary"
            @click="enter"
          >
            {{ $t('messages.enterButton') }}
          </v-btn>
        </v-card>
      </div>
      <div align='center'>
        <span>{{ $t('messages.inquiry1') }}<a :href="`/cp/${this.$store.state.current.campaign.emailSigninHash}/me/help`" target="_blank">{{ $t('messages.inquiry2') }}</a>{{ $t('messages.inquiry3') }}</span>
      </div>
    </v-flex>

    <v-flex text-xs-left v-if="isTwitter">
      <v-card
        class="mb-3 elevation-0"
        color="grey lighten-4"
        style="padding: 15px;"
      >
        <v-flex v-html="$t('messages.twitterLoginMessage')"></v-flex>
      </v-card>
      <div style="display: flex; flex-direction: row; justify-content: center; padding: 12px;">
        <v-card style="width: 100%; max-width: 500px; padding: 16px; display: flex; flex-direction: column; align-items: center;">
          <div v-if="hasError" style="color: red; width: 100%; padding: 16px; padding-top: 0px; text-align: left;">
            <span style="white-space: pre-wrap;">{{
              apiErrorMessage
            }}</span>
          </div>
          <v-btn
            color="primary"
            @click="signup"
          >
            {{ $t('messages.twitterEnterButton') }}
          </v-btn>
        </v-card>
      </div>
      <div align='center'>
        <span>{{ $t('messages.inquiry1') }}<a :href="`/cp/${this.$store.state.current.campaign.emailSigninHash}/me/help`" target="_blank">{{ $t('messages.inquiry2') }}</a>{{ $t('messages.inquiry3') }}</span>
      </div>
    </v-flex>

  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { Auth, Me } from '@/api';
import { EnumSourceTypes } from '@/enum/enum.js';
import StorageManager from '../../utils/StorageManager';
import TextInput from '@/components/atoms/TextInput.vue';
import TokenManager from '@/utils/TokenManager';

export default {
  components: {
    TextInput
  },
  data() {
    return {
      thirdPartyAuthUrl: '',
      sourceType: '',
      isDisabled: false,
      hasError: false,
      hasSessionError: false,
      hasUnexpectedError: false,
      confirmChecked: false,
      instagramUserName: '',
      apiErrorMessage: ''
    };
  },
  computed: {
    ...mapGetters({ campaign: 'getCurrentCampaign' }),
    isInstagram: function() {
      return this.sourceType === EnumSourceTypes.Instagram;
    },
    isTwitter() {
      return this.sourceType === EnumSourceTypes.Twitter;
    },
    contactUs() {
      return this.$store.state.current.campaign.contactUrl;
    }
  },
  methods: {
    signup() {
      sessionStorage.setItem('bonjiriTokenKey', this.$route.params.emailVerifyHash);
      sessionStorage.setItem('isRedirectFromTw', 'true');
      window.location.href = this.thirdPartyAuthUrl;
    },
    async enter() {
      try {
        const data = await Auth.instagramVerify({
          token: this.$route.params.emailVerifyHash,
          igName: this.instagramUserName
        });
        
        if (data.result.success === true) {
          TokenManager.set(data.result.auth.token);
          sessionStorage.setItem('isRedirectFromIg', 'true');
          //画面遷移のため、キャンペーンハッシュを取得
          Me.fetchMe()
            .then((result) => {
              //ログイン後画面へ遷移
              window.location.href = `/cp/${result.campaign.emailSigninHash}/me`;
            });
        } else {
          throw new Error('result faild.');
        }
      } catch (error) {
        this.apiErrorMessage = '';
        if (error.errors && error.errors.length > 0) {
          for (let err of error.errors) {
            console.log(err.code);
            this.apiErrorMessage += err.code + '\n';
          }
        } else {
          this.apiErrorMessage += this.$t('messages.defaultErrorMessage');
        }
        //エラー発生のため、エラー表示
        this.hasError = true;
      }
    }
  },
  mounted: function() {
    //メールアドレスの検証
    Auth.emailConfirmed({ emailVerifyHash: this.$route.params.emailVerifyHash })
      .then(result => {
        //キャンペーンコードの保存
        StorageManager.setItem(
          'CAMPAIGN_CODE_SESSION_KEY',
          result.data.campaign.emailSigninHash
        );

        //キャンペーン情報を設定
        this.$store.dispatch('setCurrentCampaign', result.data.campaign);
        this.sourceType = result.data.signupInfo.sourceType;

        //twitterの場合ログインボタンのリンク先を設定
        if (this.sourceType == EnumSourceTypes.Twitter) {
          this.thirdPartyAuthUrl = result.data.signupInfo.thirdPartyAuthUrl;
        }
      })
      .catch(error => {
        this.hasError = true;
        if (error.http.statusCode === 401) {
          this.hasSessionError = true;
        } else {
          this.hasUnexpectedError = true;
          this.hasError = true;
        }
      });
  }
};
</script>

<style scoped>
.signup-message {
  /* font-size: 2.4vh; */
  text-align: left;
}
.signup-errormessage {
  margin: 32px;
  width: auto;
}
.login-notice {
  margin-top: 24px;
}
</style>
